import type { Service } from '../wire';

/**
 * Her headings in the order her menu first reaches them — the list arrives in
 * her order already (`Mirror.services` sorts by `sort_order`), so a heading's
 * place is its first row's place. Rows with no heading form one unheaded group,
 * placed where its first row falls.
 *
 * Shared by the Settings menu and the booking sheet's service picker, so the
 * card she edits and the list she books from cannot drift into two orders.
 */
export function groupByCategory<S extends Pick<Service, 'category'>>(
  rows: readonly S[],
): [string | null, S[]][] {
  const groups = new Map<string | null, S[]>();
  for (const s of rows) {
    const heading = s.category ?? null;
    const list = groups.get(heading);
    if (list === undefined) groups.set(heading, [s]);
    else list.push(s);
  }
  return [...groups.entries()];
}
